import React from "react";
import IframeResizer from "react-iframe-resizer-super";
import UserStore from "../../stores/UserStore";

class LiveEventDiagnostics extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const destination = `${
      process.env.WATCH_SITE_ROOT
    }admin/analytics?data=${btoa(
      JSON.stringify({
        type: "live_event_log",
        virtual_content_id: this.props.virtualContentId,
        ...UserStore.getCredentials()
      })
    )}`;

    return (
      <div style={{ position: "relative" }}>
        <IframeResizer
          style={{
            width: "1px",
            minWidth: "100%",
            border: "none"
          }}
          src={destination}
        />
      </div>
    );
  }
}

export default LiveEventDiagnostics;



// WEBPACK FOOTER //
// ./src/app/components/partials/live-event-diagnostics.jsx